import React, { useEffect, useState } from 'react'
import API from '../../../../../services/API'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import {
  Button,
  Stack,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import CustomDataGrid from '../../../../../components/DataGrid/CustomDataGrid'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import moment from 'moment'
import { TableBar } from '@mui/icons-material'

const Match = () => <CheckCircleIcon color="success" />
const Issue = () => <CancelIcon color="error" />

const ControlledDrugs = ({ employeeID }) => {
  const [loading, setLoading] = useState(true)
  const [fetchError, setFetchError] = useState(false)
  const [cdChecks, setCdChecks] = useState([])
  const [frequencyWeeks, setFrequencyWeeks] = useState(52)
  const navigate = useNavigate()

  useEffect(() => {
    API.get('/medsmx/employee-cd-audits/latest/' + employeeID)
      .then((res) => {
        if (res.status === 200) {
          setCdChecks(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Grid item xs={12} lg={6}>
      <DetailsBox
        title="Controlled Drug Checks"
        noBorder
        buttonRight={
          <Button
            color="anPurple"
            size="small"
            onClick={() => navigate(`/create-cd-audit/${employeeID}`)}
            variant="outlined"
          >
            Record New{' '}
          </Button>
        }
      >
        <Stack spacing={1}>
          {cdChecks.map((check) => (
            <Paper
              key={check._id}
              elevation={1}
              onClick={() => navigate(`/cd-audit/${check._id}`)}
              sx={{
                p: 1.5,
                borderRadius: 2,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                transition: '0.2s',
                '&:hover': {
                  boxShadow: 3,
                  bgcolor: '#f9f9f9',
                },
              }}
            >
              <Stack>
                <strong>{check.medicineName}</strong>
                <span style={{ color: '#666', fontSize: 13 }}>
                  {moment(check.auditDate).format('DD MMM YYYY')}
                </span>
              </Stack>
              {check.hasIssues ? (
                <Issue sx={{ fontSize: 28 }} />
              ) : (
                <Match sx={{ fontSize: 28 }} />
              )}
            </Paper>
          ))}
        </Stack>
      </DetailsBox>
    </Grid>
  )
}

export default ControlledDrugs
